import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/question/page',
  ADD: '/dh-datamaint/question/insert',
  DELETE: '/dh-datamaint/question/batchDelete',
  DETAIL: '/dh-datamaint/question/edit',
  UPDATE: '/dh-datamaint/question/update',
  BATCH_UPDATE: '/dh-datamaint/question/batchUpdate',
  UPDATE_LITE: '/dh-datamaint/question/updateLite',
  LIST: '/dh-datamaint/lang/list',
  GET_SORT: '/dh-datamaint/question/moveInfo',
  SORT: '/dh-datamaint/question/move',
  LANG_LIST: '/dh-datamaint/lang/list',
  TYPE_LIST: '/dh-datamaint/questionType/listAll',
  TREE_LIST: '/dh-datamaint/questionSubject/listSbjCatalogTree',
  IMPORT: '/dh-datamaint/question/import',
  PREVIEW: '/dh-datamaint/question/preview',
  PAGE_IMPORT: '/dh-datamaint/fileImport/page'
};

class QuestionManageModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getTreeList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.TREE_LIST, { params: payload.data });
    },

    async getPage(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.post(URL.PAGE, payload.data,
        { params: { pageNo: payload.data.pageNo, pageSize: payload.data.pageSize } });
      return res;
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async UpdateLite(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE_LITE, payload.data);
    },

    async BatchUpdate(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.BATCH_UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, payload.data);
    },

    async getLangList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.LANG_LIST, { params: payload.data });
    },

    async getTypeList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.TYPE_LIST, { params: payload.data });
    },

    async import(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.IMPORT, payload.data);
    },

    async getSort(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_SORT, { params: payload.data });
    },

    async sort(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SORT, payload.data);
    },

    async getPreview(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PREVIEW, { params: payload.data });
    },

    async getImRecPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT, { params: payload.data });
    }
  };
}

export const questionManageModule = new QuestionManageModule();
